import React from "react";
import HeroPoster from "./HeroPoster";

// Hero banners with order 1 (Admin -> Hero banners)
const Poster = () => <HeroPoster order={1} variant="poster" />;

export default Poster;
